<template>
  <f7-popup class="ms-detail-popup">
    <f7-page>

      <f7-navbar :title="selectedName">
        <f7-nav-right>
          <f7-link popup-close>Zavrieť</f7-link>
        </f7-nav-right>
      </f7-navbar>

      <f7-block strong class="no-padding no-margin no-border-top">

        <template v-if="errorMsg">
          <f7-card>
            <f7-card-content>
              {{ errorMsg }}
            </f7-card-content>
          </f7-card>
        </template>
        <template v-else>

          <pinch-zoom>
            <img ref="imgMeteogram" :src="meteosuchoUrl" class="ms-resp">
          </pinch-zoom>
        </template>

      </f7-block>

    </f7-page>
  </f7-popup>

</template>
<script>
import SHMUconf from "../js/SHMUconf";
import PinchZoom from 'vue-pinch-zoom';
import store from "../js/store";

export default {
  components: {
    'pinch-zoom': PinchZoom
  },
  data: function () {
    return {
      feature: store.getters.getSelectedMeteoSuchoFeature,
      errorMsg: null,
    };
  },
  computed : {
    meteosuchoUrl() {
      if (this.notEmptyObject(this.feature)) {
        return SHMUconf.SHMU_CORE_URL + 'data/' + this.feature.properties.image;
      }
    },
    selectedName() {
      if (this.notEmptyObject(this.feature)) {
        return this.feature.properties.name;
      }
    }

  },
  mounted() {
    if (!this.notEmptyObject(this.feature)) {
      this.errorMsg = 'Nebola vybraná stanica pre zobrazenie grafu meteorologického sucha!';
    }


  },
  updated() {
  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {


  }

};
</script>

<style lang="scss">


.ms-resp {
  object-fit: contain;
  width: 100%;
  height: 100%;
}


</style>
